module.exports = __webpack_public_path__ + "img/blueEqualIcon.9d378025.svg";